import { FieldMappingField, FieldMappingFieldProps } from '@components/field-mapping-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFieldMappingFieldProps<T = unknown> = FormFieldProps<FieldMappingFieldProps, T>;

export function FormFieldMappingField<T>(props: FormFieldMappingFieldProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'text-editor' });

  return <FieldMappingField {...props} {...formFieldProps} />;
}
